<div>
    <mat-form-field appearance="outline">
        <mat-label>Search collections...</mat-label>
        <input matInput [formControl]="collectionSearchControl"/>
    </mat-form-field>
</div>
<div>
    <mat-accordion [multi]="false">
        <mat-expansion-panel *ngFor="let layer of filteredLayers; let i = index"
                             [disabled]="layer.disabled">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <b>{{ layer.key }}</b>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="layer.items">
                <div class="container-coverages-viewport">
                <cdk-virtual-scroll-viewport [itemSize]="10" class="coverages-viewport">
                    <div *cdkVirtualFor="let collection of layer.items">
                        <div class="d-flex justify-content-start" >
                            <mat-icon class="px-1" (click)="goTo(collection)">location_on</mat-icon>
                            <mat-checkbox [checked]="collection.painted" [matTooltip]="collection.properties.collection" [disabled]="collection.disabled"
                                              (change)="changeCollectionCoverageStatus(collection, $event)">
                                <span class="d-flex"><span class="collection-name">{{ collection.properties.collection }}</span></span>
                            </mat-checkbox>
                            <mat-icon class="px-2 align-self-end" [hidden]="!collection.visible">visibility</mat-icon>
                        </div>
                    </div>
                </cdk-virtual-scroll-viewport>
                </div>
            </ng-container>
            <ng-container *ngIf="!layer.items">
                <p>Loading collections...</p>
            </ng-container>

        </mat-expansion-panel>
    </mat-accordion>
</div>